export const components = {

    /*
    * Global components
    */
    globals: [
        { name: 'app-message', src: 'app_message.vue' },
        { name: 'v-checkbox', src: 'checkbox.vue' },
        { name: 'v-checkbox2', src: 'checkbox-2.vue' }, // new
        { name: 'v-switch', src: 'switch.vue' },
        { name: 'v-switch2', src: 'switch-2.vue' }, // new
        { name: 'v-loading', src: 'loading.vue' },
        { name: 'v-upload', src: 'upload.vue' },
        { name: 'v-password', src: 'password-field.vue' },
        { name: 'cod-elm', src: 'article/cod-element.vue' },
        { name: 'image-elm', src: 'article/image-element.vue' },
        { name: 'lang-selector', src: 'lang-selector.vue' },
        { name: 'lang-selector-new', src: 'lang-selector-new.vue' },
        { name: 'price-elm', src: 'article/price-element.vue' },
    ],

    /*
    * Default area components
    */
    admin: [
        { name: 'v-menu', src: 'admin/menu.vue' },
        { name: 'v-footer', src: 'admin/footer.vue' }
    ],

    reserved: [
        { name: 'v-menu', src: 'reserved/menu.vue' },
        { name: 'v-footer', src: 'reserved/footer.vue' }
    ],

    public: [
        { name: 'v-menu', src: 'public/menu.vue' },
        //   {name: 'footer-info', src: 'public/footer-info.vue'},
        { name: 'smart-login', src: 'public/smart-login.vue' },
        { name: 'family-box', src: 'public/family-box.vue' },
        { name: 'macrofamily-section', src: 'public/macrofamily-section.vue' },
        { name: 'link-page-back', src: 'public/link-page-back.vue' },
        { name: 'fesr', src: 'public/fesr.vue' },
    ],

    /*
    * Exclusions
    */
    exclusions: {
        // header: ['login', 'password_recovery', 'reset_password']
    },

    /*
    * Components list
    */

    /**********************
     * Auth
     **********************/
    login: [
        { name: 'login', src: 'public/login/login.vue' }
    ],
    password_recovery: [
        { name: 'password-recovery', src: 'public/login/password-recovery.vue' }
    ],
    password_reset: [
        { name: 'password-reset', src: 'public/login/password-reset.vue' }
    ],
    verify_user: [
        { name: 'user-verification', src: 'public/login/verification.vue' }
    ],

    /**********************
     * Public
     **********************/
    register_user: [
        { name: 'register-user', src: 'public/register-user.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },
    ],
    home: [
        { name: 'home', src: 'public/home/index.vue' },
        { name: 'ns-prodotti', src: 'public/nostri-prodotti/ns-prodotti.vue' },
        { name: 'ns-prodotti-2', src: 'public/nostri-prodotti/ns-prodotti-2.vue' },
        { name: 'industrie', src: 'public/nostri-prodotti/industrie.vue' },
        { name: 'materials', src: 'public/nostri-prodotti/materials.vue' },
        { name: 'materials-2', src: 'public/nostri-prodotti/materials-2.vue' },
        { name: 'gallery', src: 'public/gallery.vue' },


        // {name: 'form-newsletter', src: 'public/form-newsletter.vue'},
        // {name: 'form-contact', src: 'public/form-contact.vue'},
    ],
    macrofamily: [
        { name: 'macrofamily', src: 'public/macrofamily/index.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },
    ],
    family: [
        { name: 'family', src: 'public/family/index.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },
    ],
    archive_category: [
        { name: 'archive-category', src: 'public/archive-category/index.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },
    ],
    about_us: [
        { name: 'about-us', src: 'public/about-us/index.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },
    ],
    downloads: [
        { name: 'downloads', src: 'public/downloads/index.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },

    ],
    four_custom: [
        { name: 'four-custom', src: 'public/four-custom/index.vue' },
        { name: 'form-newsletter', src: 'public/form-newsletter.vue' },
        { name: 'form-contact', src: 'public/form-contact.vue' },
        { name: 'gallery', src: 'public/gallery.vue' },
    ],

    contact_us: [
        { name: 'contact-us', src: 'public/contact-us/index.vue' },
    ],

    catalog: [
        {name: 'catalog', src: 'public/catalog/index.vue'},
        {name: 'form-newsletter', src: 'public/form-newsletter.vue'},
        {name: 'form-contact', src: 'public/form-contact.vue'},

    ],

    macro: [
        {name: 'macro', src: 'public/catalog/macro.vue'},
        {name: 'form-newsletter', src: 'public/form-newsletter.vue'},
        {name: 'form-contact', src: 'public/form-contact.vue'},

    ],






    productView: [
        {name: 'product-view', src: 'public/catalog/product-view.vue'},
        /*
        * nuovo componente con le card 14/04/2022
        * */
        {name: 'product-view-w-card', src: 'public/catalog/product-view-w-card.vue'},
        /*
        *
        * */
        {name: 'form-newsletter', src: 'public/form-newsletter.vue'},
        {name: 'form-contact', src: 'public/form-contact.vue'},

    ],

    four_engeneering: [
        { name: 'four-engeneering', src: 'public/four-engeneering/index.vue' },
    ],

    four_one: [
        { name: 'four-one', src: 'public/four-engeneering/four-one.vue' },
    ],

    Banchi: [
        { name: 'Banchi', src: 'public/four-engeneering/Banchi.vue' },
    ],
    privacy_policy: [
        {name: 'privacy', src: 'privacy.vue'},
    ],






    /**********************
     * Reserved
     **********************/
    home_b2b: [
        { name: 'home', src: 'reserved/home/index.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    macrofamily_b2b: [
        { name: 'macrofamily', src: 'reserved/macrofamily/index.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    family_b2b: [
        { name: 'family', src: 'reserved/family/index.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },

    ],
    category_b2b: [
        { name: 'articles', src: 'reserved/article/index.vue' },
        //{name: 'article-card', src: 'reserved/article/search-article-card.vue'},
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'search', src: 'reserved/article/search.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    article_b2b: [
        { name: 'prodotti', src: 'reserved/article/prodotti.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'search', src: 'reserved/article/search.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    article_uncat_b2b: [

        { name: 'prodotti-uncat', src: 'reserved/article/prodotti-uncat.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'search', src: 'reserved/article/search.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    microfamily_b2b: [
        { name: 'microfamily', src: 'reserved/microfamily/index.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    archive_category_b2b: [
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    search_b2b: [
        { name: 'search', src: 'reserved/search/index.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    catcolor_b2b: [
        { name: 'catcolor', src: 'reserved/catcolor/index.vue' },
        { name: 'search', src: 'reserved/article/search.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    checkout_b2b: [
        { name: 'search', src: 'reserved/search.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'checkout', src: 'reserved/checkout/index.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],

    checkout_success_b2b: [
        { name: 'search', src: 'reserved/search.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'checkout', src: 'reserved/checkout/index.vue' },
        { name: 'checkout_success_b2b', src: 'reserved/checkout/checkout_success_b2b.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },

    ],

    personal_b2b: [
        { name: 'search', src: 'reserved/search.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'checkout', src: 'reserved/checkout/index.vue' },
        { name: 'personal-area', src: 'reserved/personal-area/index.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },
    ],
    privacy_policy_b2b: [
        {name: 'privacy', src: 'privacy.vue'},
        { name: 'search', src: 'reserved/search.vue' },
        { name: 'cart', src: 'reserved/cart/cart.vue' },
        { name: 'footer_b2b', src: 'reserved/footer.vue' },
        { name: 'checkout', src: 'reserved/checkout/index.vue' },
        { name: 'personal-area', src: 'reserved/personal-area/index.vue' },
        { name: 'acquisto-v', src: 'reserved/acquisto-veloce.vue' },

    ],


    /**********************
     * Admin
     **********************/
    shipping_areas: [
        { name: 'shipping-areas', src: 'admin/shipping-cost/index.vue' }
    ],
    messages: [
        { name: 'messages', src: 'admin/messages/index.vue' }
    ],

    admin_home: [
        { name: 'admin-home', src: 'admin/home.vue' }
    ],
    admin_settings: [
        { name: 'platform-settings', src: 'admin/settings/settings.vue' }
    ],
    admin_customers: [
        { name: 'customers', src: 'admin/customers/customers.vue' }
    ],
    admin_updating_sync: [
        { name: 'updating-sync', src: 'admin/sync/index.vue' }
    ],
    admin_media: [
        { name: 'admin-media', src: 'admin/media/media.vue' }
    ],
    admin_images: [
        { name: 'admin-images', src: 'admin/images/index.vue' }
    ],
    admin_translations: [
        { name: 'translations', src: 'admin/translations/index.vue' }
    ],
    admin_downloads: [
        { name: 'admin-downloads', src: 'admin/downloads/index.vue' }
    ],
    admin_mod_art: [
        { name: 'admin-mod-art', src: 'admin/mod-art/index.vue' }
    ],
    admin_ordinamento: [
        { name: 'ordinamento', src: 'admin/ordinamento/index.vue' }
    ]


};
